
var navbarNav = $('.desktop.navbar-nav'),
    navbarBrand = navbarNav.find('.navbar-brand'),
    products = navbarNav.find('.products'),
    discover = navbarNav.find('.discover'),
    resources = navbarNav.find('.resourceslink'),
    customlabs = navbarNav.find('.customlabs'),
    contactus = navbarNav.find('.contactus'),
    newslink = navbarNav.find('.newslink'),
    navDropdowns = $('.nav-dropdowns'),
    leftNav1 = navDropdowns.find('.menu-1'),
    leftNav2;

var wallcovering_1 = function(){
  // desktop
  leftNav1.removeClass('fade');
  navDropdowns.find('.menu-2').addClass('fade');
  navDropdowns.find('.menu-3').addClass('fade');

  navDropdowns.find('ul.menu-11').addClass('fade');
  navDropdowns.find('ul.menu-22').addClass('fade');
  navDropdowns.find('ul.menu-33').addClass('fade');

  var rightNav = navDropdowns.find('ul.wallcovering').removeClass('fade');
  navDropdowns.removeClass('fade hide');
  
  navbarNav.find('.nav-item').removeClass('active');
  products.parent().addClass('active');

  // var hh = Math.ceil(rightNav.outerHeight(true));
  var hh = Math.floor(rightNav.outerHeight(true));
  // navDropdowns.css('height', hh+'px');
  
}

var wallcovering_2 = function(){
  // mobile
  var mobileHamburger = $('#mobile-hamburger'),
      navbarToggler1 = $('#navbarToggler1'),
      mobileNavbar = navbarToggler1.find('ul.mobile.navbar-nav');

  mobileHamburger.click();

  setTimeout(function() {  
    mobileNavbar.find('li').eq(0).find('a').click();
  }, 500);
}

var checkMediaWidth = function(){
  var platform = 'desktop';
  // @media screen and (max-width: 992px) and (min-device-width: 320px) 
  if (window.matchMedia('(max-width: 992px)').matches && window.matchMedia('(min-width: 320px)').matches) {
    platform = 'mobile';
  }
  
  return platform;
}


function navInit(){
  
  products.on('mouseenter', function(){
    navDropdowns.addClass('fade');
    navDropdowns.find('> div').addClass('collapse');
    
    navbarNav.find('.nav-item').removeClass('active');
    $(this).parent().addClass('active');

    //submenu show
    navDropdowns.find('.products-menu').removeClass('collapse');
    navDropdowns.removeClass('fade hide');
  }).on('mouseleave', function(){
    $(this).parent().removeClass('active');
  });


  discover.on('mouseenter', function(){
    navDropdowns.addClass('fade');
    navDropdowns.find('> div').addClass('collapse');
    navbarNav.find('.nav-item').removeClass('active');
    $(this).parent().addClass('active');

    //submenu show
    navDropdowns.find('.discover-menu').removeClass('collapse');
    navDropdowns.removeClass('fade hide');
  }).on('mouseleave', function(){
    $(this).parent().removeClass('active');
  });

  resources.on('mouseenter', function(){
    navDropdowns.addClass('fade');
    navDropdowns.find('> div').addClass('collapse');
    navbarNav.find('.nav-item').removeClass('active');
    $(this).parent().addClass('active');

    //submenu show
    navDropdowns.find('.resources-menu').removeClass('collapse');
    navDropdowns.removeClass('fade hide');
  }).on('mouseleave', function(){
    $(this).parent().removeClass('active');
  });

  contactus.on('mouseenter', function(){
    navDropdowns.addClass('fade');
    navDropdowns.find('> div').addClass('collapse');
    navbarNav.find('.nav-item').removeClass('active');
    $(this).parent().addClass('active');

    //submenu show
    navDropdowns.find('.aboutus-menu').removeClass('collapse');
    navDropdowns.removeClass('fade hide');
  }).on('mouseleave', function(){
    $(this).parent().removeClass('active');
  });

  customlabs.on('mouseenter', function(){
    navDropdowns.addClass('fade');
    
    navbarNav.find('.nav-item').removeClass('active');
    $(this).parent().addClass('active');

    navDropdowns.css('height', '');
  }).on('mouseleave', function(){
    $(this).parent().removeClass('active');
  });

  newslink.on('mouseenter', function(){

    navDropdowns.find('.menu-3').removeClass('fade');    
    navDropdowns.find('.menu-1').addClass('fade');
    navDropdowns.find('.menu-2').addClass('fade');

    navDropdowns.find('ul.menu-11').addClass('fade');
    navDropdowns.find('ul.menu-22').addClass('fade');
    navDropdowns.find('ul.menu-33').addClass('fade');
    navDropdowns.find('ul.news').removeClass('fade');
    navDropdowns.removeClass('fade hide');    

    navbarNav.find('.nav-item').removeClass('active');
    $(this).parent().addClass('active');

    var rightNav = navDropdowns.find('ul.wallcovering');
    
    var hh = Math.floor(rightNav.outerHeight(true));
    navDropdowns.css('height', hh+'px');

    // var hh = Math.ceil(rightNav.outerHeight(true));
    //var hh = Math.floor(rightNav.outerHeight(true));
    //leftNav2.css('height', hh+'px');
  });

  navbarBrand.mouseenter(function() {
    navDropdowns.addClass('fade');
    
    navDropdowns.css('height', '');
  });
  navDropdowns.mouseleave(function() {
    navDropdowns.addClass('fade');
    
    navDropdowns.css('height', '');
    navbarNav.find('.nav-item').removeClass('active');
  });

  $(document).mouseleave(function () {
    navDropdowns.addClass('fade');
    
    navDropdowns.css('height', '');
    navbarNav.find('.nav-item').removeClass('active');
  });


  // view side nav
  navDropdowns.find('a.wallcovering').on('mouseenter', function(){
    navDropdowns.find('ul.menu-11').addClass('fade');
    navDropdowns.find('ul.wallcovering').removeClass('fade');
  });
  navDropdowns.find('a.faux_leather').on('mouseenter', function(){
    navDropdowns.find('ul.menu-11').addClass('fade');
    navDropdowns.find('ul.faux_leather').removeClass('fade');
  });
  navDropdowns.find('a.sheers_drapery').on('mouseenter', function(){
    navDropdowns.find('ul.menu-11').addClass('fade');
    navDropdowns.find('ul.sheers_drapery').removeClass('fade');
  });

  // https://stackoverflow.com/questions/43707615/bootstrap-css-dropdown-menu-animation


  // footer
  setTimeout ( function () {
    $('footer.page-footer').removeClass('hide');
  }, 250);


  var mobile = $('nav.navbar .mobile');
  mobile.find('.dropdown-menu a.dropdown-toggle').on('click tap', function(e) {
    if (!$(this).next().hasClass('show')) {
      $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
      //console.log(111);
    }
    var $subMenu = $(this).next(".dropdown-menu");
    $subMenu.toggleClass('show');


    $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
      $('.dropdown-submenu .show').removeClass("show");
      //console.log(222);
    });


    return false;
  });

  const navmenu1 = document.getElementById('desktop-navmenu');
  const navmenu2 = document.getElementById('desktop-navmenu2');

  navmenu2.addEventListener('click', function(e) {
    navmenu2.style.display = 'none';
    navmenu1.style.display = 'flex';
  })
}

function PLPpage(){
  // close modal
  var modalContainer = $('#modal-product-container').on('hide.bs.modal', function () {
      $('#plp-modal-img1').attr('src', '');
      modalContainer.find('.container-fluid ul').addClass('hide');
      modalContainer.find('#plp-sample-btn button').prop("disabled", false);
  });
  
  var bc = $('ol.breadcrumb');
  var bcA = bc.find('.breadcrumb-item.wallcovering a');

  bcA.on('click tap', function(){
    var platform = checkMediaWidth();

    if(platform=='desktop'){
      wallcovering_1();
    }else{
      // mobile
      wallcovering_2();
    }

    return false;
  });
}

function showroomsInit(){

  var nav = $('#showrooms-container').find('.nav');
  nav.find('li a').on('click tap', function(e) {


    var topNavH = 10; //$('nav.navbar').outerHeight();
    var myId = $(this).attr('href');

    scrollIt(topNavH, myId);

    //return false;
  });
}

function customlabsInit(){
  //console.log(123);

  // past projects
  var fabricName = $('.fabricName');
  var modalCustomlabsContainer = $('#modal-customlabs-container');
  var myOwl = modalCustomlabsContainer.find('.owl-carousel');

  fabricName.on('click tap', function(){
    var ii = $(this).parents('li').index();

    myOwl.owlCarousel({
      margin: 10,
      dots: false,
      nav: false,
      //navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
      responsive: {
          0: {
            items: 1
          } 
      },
      startPosition: ii,
    });
    
    //return false;
  });

  modalCustomlabsContainer.on('hide.bs.modal', function () {
    modalCustomlabsContainer.find('.owl-carousel').trigger('destroy.owl.carousel'); 
  });

}

function homeInit() {  
  var payBtn = $('.active.payBtn');
  payBtn.on('click tap', function(){
    var payUrl = "/pay/" + $(this).attr('href');
    var dataObj = $("meta[name=csrf-token]").attr("content");    

    $.ajax({ type: "POST",
        //async: false,
        data: {  _token: dataObj },
        url: payUrl ,
        //dataType: "json", // << IF jSON
        success: function(data){
          window.open(data, '_blank');
        }
    });

    return false;
  });  
}

$(document).ready(function(){
  // main top, footer nav
  navInit(); 

  var plp = document.getElementById("productcontainer");
  var showrooms = document.getElementById("showrooms-container");
  var customlabs = document.getElementById("customlabs");
  var home = document.getElementById("home");

  if(plp){
    PLPpage();
  }else if(showrooms){
    showroomsInit();
  }else if(customlabs){
    customlabsInit();
  }else if(home){
    homeInit();
  }
});


function scrollIt(topNavH,myId){

  var topInt = $(myId).offset().top - topNavH + 2; // add small xtra pad

  $('html, body').animate({
      scrollTop: topInt
  }, 300);
}

function popitup(url, ww, hh) {

  var newwindow = window.open(url,'myPopup','width='+ ww +',height=' + hh);
  if (window.focus) {newwindow.focus()}
  
  return false;
};